/* eslint-disable */
import { Factory } from '../flyweight';
import { Reader, Writer } from 'protobufjs/minimal';
import { Int32Value, StringValue } from '../protobuf/wrappers';

export const protobufPackage = 'tencent.docs.model';

/** <xsd:complexType name=sml:CT_NumFmtSml name="CT_NumFmtSml"> */
export interface ICTNumFmt {
    /** <xsd:attribute typeRedirected=xsd:integer name="numFmtId" type="ST_NumFmtId" use="required"> */
    numFmtId?: number;
    /** <xsd:attribute typeRedirected=xsd:string name="formatCode" type="s:ST_Xstring" use="required"> */
    formatCode?: string;
}
interface ICTNumFmtTag {
    numFmtIdI?: boolean;
    formatCodeI?: boolean;
}
type CTNumFmtWithTag = ICTNumFmt & ICTNumFmtTag;
type CTNumFmtKey = keyof ICTNumFmt;

export class CTNumFmt {
    public static readonly factory = new Factory<CTNumFmt, ICTNumFmt>(CTNumFmt);
    public static keyList: CTNumFmtKey[] = ['numFmtId', 'formatCode'];
    public static generateKey(options: ICTNumFmt): string {
        let key = '{';
        if (options?.numFmtId !== undefined) {
            key = `${key}${options.numFmtId}${CTNumFmt.keyList.indexOf('numFmtId')}`;
        }

        if (options?.formatCode !== undefined) {
            key = `${key}${options.formatCode}${CTNumFmt.keyList.indexOf('formatCode')}`;
        }
        return `${key}}`;
    }
    public static createAttributeInstance(options: ICTNumFmt): CTNumFmt {
        const newInstance = new CTNumFmt(options);
        return newInstance;
    }
    public static deserializeBuffer<T extends keyof ICTNumFmt>(options: CTNumFmtWithTag) {
        const newOptions: ICTNumFmt = {};
        if (!options || typeof options !== 'object') {
            return options;
        }
        CTNumFmt.keyList.forEach((key: T) => {
            if (options[key] !== undefined) {
                newOptions[key] = options[key];
            }
        });
        return newOptions;
    }
    public static preSerialize<T extends keyof ICTNumFmt>(data: ICTNumFmt): CTNumFmtWithTag {
        const newInstance: CTNumFmtWithTag = {};
        CTNumFmt.keyList.forEach((key: T) => {
            if (data[key] !== undefined) {
                newInstance[key] = data[key];
            }
        });
        return newInstance;
    }
    public static decode(input: Reader | Uint8Array, length?: number) {
        const reader = input instanceof Reader ? input : new Reader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message: any = {};
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.numFmtId = Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 2:
                    message.numFmtIdI = reader.bool();
                    break;
                case 3:
                    message.formatCode = StringValue.decode(reader, reader.uint32()).value;
                    break;
                case 4:
                    message.formatCodeI = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    }
    public static encode(message: any, writer: Writer = Writer.create()): Writer {
        if (message.numFmtId !== undefined) {
            Int32Value.encode({ value: message.numFmtId! }, writer.uint32(10).fork()).ldelim();
        }
        if (message.numFmtIdI !== undefined) {
            writer.uint32(16).bool(message.numFmtIdI);
        }
        if (message.formatCode !== undefined) {
            StringValue.encode({ value: message.formatCode! }, writer.uint32(26).fork()).ldelim();
        }
        if (message.formatCodeI !== undefined) {
            writer.uint32(32).bool(message.formatCodeI);
        }
        return writer;
    }
    /** <xsd:attribute typeRedirected=xsd:integer name="numFmtId" type="ST_NumFmtId" use="required"> */
    numFmtId?: number;
    /** <xsd:attribute typeRedirected=xsd:string name="formatCode" type="s:ST_Xstring" use="required"> */
    formatCode?: string;
    constructor(options?: ICTNumFmt, private key?: string) {
        if (options?.numFmtId !== undefined) {
            this.numFmtId = options.numFmtId;
        }
        if (options?.formatCode !== undefined) {
            this.formatCode = options.formatCode;
        }
    }
    public equal(instance: CTNumFmt): boolean {
        return this.numFmtId === instance.numFmtId && this.formatCode === instance.formatCode;
    }
    public clone(): CTNumFmt {
        const options: ICTNumFmt = {};
        options.numFmtId = this.numFmtId;
        options.formatCode = this.formatCode;
        return CTNumFmt.factory.createInstance(options);
    }
}
